import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getPasswordStrength(password: string) {
  let score = 0
  const feedback: string[] = []

  // Handle empty password
  if (!password) {
    feedback.push('Password is required')
    return { score: 0, feedback }
  }

  // Length check
  if (password.length < 8) {
    feedback.push('Password is too short')
  } else if (password.length < 12) {
    score += 1
  } else {
    score += 2
  }

  // Lowercase check
  if (!/[a-z]/.test(password)) {
    feedback.push('Add a lowercase letter')
  } else {
    score += 1
  }

  // Uppercase check
  if (!/[A-Z]/.test(password)) {
    feedback.push('Add an uppercase letter')
  } else {
    score += 1
  }

  // Number check
  if (!/\d/.test(password)) {
    feedback.push('Add a number')
  } else {
    score += 1
  }

  // Special character check
  if (!/[^A-Za-z0-9]/.test(password)) {
    feedback.push('Add a special character')
  } else {
    score += 1
  }

  return { score: Math.min(score, 5), feedback }
}
